__turbopack_context__.v({
  "actionButton": "layout-module-scss-module__EwFtha__actionButton",
  "dotsPattern": "layout-module-scss-module__EwFtha__dotsPattern",
  "footerCol": "layout-module-scss-module__EwFtha__footerCol",
  "footerContent": "layout-module-scss-module__EwFtha__footerContent",
  "footerPattern": "layout-module-scss-module__EwFtha__footerPattern",
  "landingHomeContainer": "layout-module-scss-module__EwFtha__landingHomeContainer",
  "landingPageContainer": "layout-module-scss-module__EwFtha__landingPageContainer",
  "mailLink": "layout-module-scss-module__EwFtha__mailLink",
  "mdContainer": "layout-module-scss-module__EwFtha__mdContainer",
  "mobileMenu": "layout-module-scss-module__EwFtha__mobileMenu",
  "pricingGreenDiagonal": "layout-module-scss-module__EwFtha__pricingGreenDiagonal",
  "scheduleGreenDiagonal": "layout-module-scss-module__EwFtha__scheduleGreenDiagonal",
  "secondaryBtn": "layout-module-scss-module__EwFtha__secondaryBtn",
  "sectionDescription": "layout-module-scss-module__EwFtha__sectionDescription",
  "sectionTitle": "layout-module-scss-module__EwFtha__sectionTitle",
  "staticPageContainer": "layout-module-scss-module__EwFtha__staticPageContainer",
  "staticPageHeaderSubTitle": "layout-module-scss-module__EwFtha__staticPageHeaderSubTitle",
  "staticPageHeaderTitle": "layout-module-scss-module__EwFtha__staticPageHeaderTitle",
  "staticPageHeaderWrapper": "layout-module-scss-module__EwFtha__staticPageHeaderWrapper",
});
